import { Tabs, Tab } from "../../utils/globalImports";
import { useLocation } from "../../utils/globalImports";

interface TabItem {
  name: string;
  path: string;
}

interface TopBarProps {
  tabs: TabItem[]; //Dynamic tabs
  onChange?: (event: React.SyntheticEvent, value: string) => void;
  width?: string; //Optional width control
  activeColor?: string; //Custom active tab color
  textColor?: string; //Custom text color
}

const TopBar: React.FC<TopBarProps> = ({
  tabs,
  onChange,
  width = "60%", // Default to full width
  activeColor = "#1e66ab",
  textColor = "#1e66ab",
}) => {
  const location = useLocation();
  const activeTabPath = location.pathname;

  return (
    <div
      className="flex justify-center"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: "white",
        borderBottom: "2px solid #d7d7d7",
        width
      }}
    >
      <Tabs
        value={activeTabPath}
        onChange={onChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{ width: "100%", display: "flex", justifyContent: "center" }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            value={tab.path}
            sx={{
              nowrap: "nowrap",
              textTransform: "none",
              fontWeight: 500,
              flex: 1, //Ensures even spacing
              minWidth: "auto",
              maxWidth: "100%",
              color: textColor, //Customizable text color
              "&.Mui-selected": {
                backgroundColor: activeColor, //Customizable active tab color
                color: "white",
                borderRadius: "8px 8px 0 0",
              },
            }}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default TopBar;
